module.exports = __webpack_public_path__ + "img/tree-03-f-trunk.edfc1277.png";